// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"254":"6ae728ca","650":"c092a578","958":"179b6c4b"}[chunkId] + ".css";
};